<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark" sticky>
      <div class="container">
        <b-navbar-brand href="#">
          <img
            src="https://cdn.onesrc.cn/uploads/images/onepoint_30.png"
            class="d-inline-block align-top"
            alt="logo"
          />
          ONEPOINT
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <li class="nav-item">
              <router-link to="/home" class="nav-link">首页</router-link>
            </li>
            <template v-if="$store.state.isadmin">
              <li class="nav-item">
                <router-link to="/files" class="nav-link">管理</router-link>
              </li>
              <b-nav-item-dropdown text="设置">
                <li>
                  <router-link to="/setting/site" class="dropdown-item">网站信息</router-link>
                </li>
                <li>
                  <router-link to="/setting/drives" class="dropdown-item">云盘挂载</router-link>
                </li>
                <li>
                  <router-link to="/setting/password" class="dropdown-item">密码设置</router-link>
                </li>
                <li>
                  <router-link to="/setting/dev" class="dropdown-item">开发者设置</router-link>
                </li>
              </b-nav-item-dropdown>
              <li class="nav-item">
                <router-link to="/cache" class="nav-link">缓存</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/dashboard" class="nav-link">状态</router-link>
              </li>
            </template>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <li class="nav-item" v-if="!$store.state.isadmin">
              <router-link to="/login" class="nav-link">登录</router-link>
            </li>
            <b-nav-item v-else href="logout" right @click.prevent="logout">退出</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
    <router-view />

    <p class="text-muted text-center m-3">
      Designed by
      <a href="https://www.onesrc.cn/">ONESRC</a> | Powered by
      <a href="https://github.com/ukuq/onepoint">OnePoint</a>.
    </p>
  </div>
</template>
<script>
export default {
  beforeCreate() {
    let t = window.localStorage.getItem("loginTime");
    if (t && Date.now() < Number(t)) {
      this.$store.commit("loginSuccess");
    }
  },
  methods: {
    logout() {
      this.$store.commit("logoutSuccess");
      this.common.axios.get("./admin/public/logout").catch(() => {});
      this.$router.push({ path: "/login" });
    }
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
li.nav-item a.router-link-exact-active {
  color: #03a9f4 !important;
}
</style>